import React from "react";
import { OrbitProgress } from "react-loading-indicators";
import UploadManagerProgressReport from "../../model/UploadManagerProgressReport";

interface ILoadingProps {
  loadingMessage?: string;
  uploading?: boolean;
  uploadingMessage?: string | undefined;
  uploadingProgress?: UploadManagerProgressReport | undefined;
}

function Loading({
  loadingMessage,
  uploading,
  uploadingMessage,
  uploadingProgress,
}: ILoadingProps) {
  const uploadingMessageDisplay =
    uploadingMessage ?? "Please wait. Uploading files... ";

  return (
    <div className="flex flex-col justify-center align-middle items-center min-h-screen mx-8">
      <OrbitProgress variant="dotted" color="#32cd32" size="small" />
      {!uploading && !loadingMessage && (
        <p className="mt-7">Please wait. Loading...</p>
      )}
      {!uploading && loadingMessage && <p className="mt-7">{loadingMessage}</p>}
      {uploading && (
        <p className="mt-7">
          {uploadingMessageDisplay}
          {uploadingProgress && (
            <strong>{" " + uploadingProgress.progressGlobal + "%"}</strong>
          )}
        </p>
      )}
      {uploading && uploadingProgress && (
        <div className="progress-bar-outer">
          <div
            className="progress-bar-inner"
            style={{
              width: uploadingProgress.progressGlobal + "%",
              height: "10px",
            }}
          ></div>
        </div>
      )}
    </div>
  );
}

export default Loading;
